import { useForwardingTabContext } from "@/features/maintenance/features/workflows/hooks/forwardings/useForwardingTabContext";
import { MaintenanceForwardingDirectiveEntryStatus } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwarding.type";
import { MaintenanceForwardingsDirectiveEntryKlass } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwardingsDirectiveEntryKlasses.type";
import DirectiveEntryExecutionEntryAwaitingManualStart from "./AwaitingManualStart";
import DirectiveEntryExecutionEntryInProgress from "./InProgress";
import DirectiveEntryExecutionEntryAwaitingClientReview from "./AwaitingClientReview";

const DirectiveEntryExecutionEntryOnGoingDirective = () => {
  const { forwarding } = useForwardingTabContext<
    MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry
  >();

  if (forwarding.directive_entry.status === MaintenanceForwardingDirectiveEntryStatus.AwaitingManualStart) {
    return <DirectiveEntryExecutionEntryAwaitingManualStart />
  }

  if (forwarding.directive_entry.status === MaintenanceForwardingDirectiveEntryStatus.InProgress) {
    return <DirectiveEntryExecutionEntryInProgress />
  }

  if (forwarding.directive_entry.status === MaintenanceForwardingDirectiveEntryStatus.AwaitingClientReview) {
    return <DirectiveEntryExecutionEntryAwaitingClientReview />
  }

  return null;
}

export default DirectiveEntryExecutionEntryOnGoingDirective;
